import { parseIndustries, parseEntitiesIndustries } from 'shared/parsers';
import { ratingTypes } from 'shared/constants/ratingTypes';
import {
  GET_INDUSTRIES,
  GET_INDUSTRIES_SUCCESS,
  GET_INDUSTRIES_ERROR,
} from './industries/industriesActions';
import {
  REQUEST_RELATED_ENTITIES,
  REQUEST_RELATED_ENTITIES_SUCCESS,
  REQUEST_RELATED_ENTITIES_ERROR,
} from './relatedEntities/relatedEntitiesActions';
import {
  REQUEST_CREDIT_REVIEW_LEVELS,
  REQUEST_CREDIT_REVIEW_LEVELS_SUCCESS,
  REQUEST_CREDIT_REVIEW_LEVELS_ERROR,
} from './creditReviewLevels/creditReviewLevelsActions';
import { VISIT_RATING_TYPE } from './lastVisited/lastVisitedActions';
import {
  GET_RATING_COVERAGE,
  GET_RATING_COVERAGE_SUCCESS,
  GET_RATING_COVERAGE_ERROR,
} from './ratingCoverage/ratingCoverageAction';
import {
  GET_ESG_COVERAGE,
  GET_ESG_COVERAGE_SUCCESS,
  GET_ESG_COVERAGE_ERROR,
} from './esgCoverage/esgCoverageAction';
import { GET_REGIONS, GET_REGIONS_SUCCESS, GET_REGIONS_ERROR } from './regions/regionsAction';
import {
  REQUEST_QUESTIONNAIRE_AVAILABILITY_SUCCESS,
  REQUEST_QUESTIONNAIRE_AVAILABILITY_ERROR,
} from './questionnaire/questionnaireActions';
import {
  REQUEST_CREDIT_REVIEW_SPECS,
  REQUEST_CREDIT_REVIEW_SPECS_ERROR,
  REQUEST_CREDIT_REVIEW_SPECS_SUCCESS,
} from './creditReviewSpecs/creditReviewSpecsActions';

const initialState = {
  industries: {
    isPending: false,
    data: [],
  },
  relatedEntities: {
    isPending: false,
    data: [],
  },
  relatedIndustries: [],
  creditReviewSpecs: {
    isPending: false,
    data: null,
  },
  creditReviewLevels: {
    isPending: false,
    data: null,
  },
  lastVisited: {
    ratingType: ratingTypes.CREDIT_RATING,
  },
  ratingCoverage: {
    isPending: false,
    data: [],
  },
  esgCoverage: {
    isPending: false,
    data: [],
  },
  regions: {
    isPending: false,
    data: [],
  },
  questionnaire: {
    show: false,
  },
};

export function shared(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_INDUSTRIES:
      return { ...state, industries: { ...state.industries, isPending: true } };
    case GET_INDUSTRIES_SUCCESS:
      return { ...state, industries: { data: parseIndustries(payload), isPending: false } };
    case GET_INDUSTRIES_ERROR:
      return { ...state, industries: { ...state.industries, isPending: false } };
    case REQUEST_RELATED_ENTITIES:
      return { ...state, relatedEntities: { ...state.relatedEntities, isPending: true } };
    case REQUEST_RELATED_ENTITIES_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        relatedEntities: { data, isPending: false },
        relatedIndustries: parseEntitiesIndustries(data), // TODO: parse like this [{value, label}] needed state.industry and filter by name
      };
    }
    case REQUEST_RELATED_ENTITIES_ERROR:
      return { ...state, relatedEntities: { ...state.relatedEntities, isPending: false } };
    case REQUEST_CREDIT_REVIEW_LEVELS:
      return { ...state, creditReviewLevels: { ...state.creditReviewLevels, isPending: true } };
    case REQUEST_CREDIT_REVIEW_LEVELS_SUCCESS:
      return { ...state, creditReviewLevels: { data: payload, isPending: false } };
    case REQUEST_CREDIT_REVIEW_LEVELS_ERROR:
      return { ...state, creditReviewLevels: { ...state.creditReviewLevels, isPending: false } };
    case REQUEST_CREDIT_REVIEW_SPECS:
      return { ...state, creditReviewSpecs: { ...state.creditReviewSpecs, isPending: true } };
    case REQUEST_CREDIT_REVIEW_SPECS_SUCCESS:
      return { ...state, creditReviewSpecs: { data: payload, isPending: false } };
    case REQUEST_CREDIT_REVIEW_SPECS_ERROR:
      return { ...state, creditReviewSpecs: { ...state.creditReviewSpecs, isPending: false } };
    case VISIT_RATING_TYPE:
      return { ...state, lastVisited: { ...state.lastVisited, ratingType: payload.ratingType } };
    case GET_RATING_COVERAGE:
      return { ...state, ratingCoverage: { ...state.ratingCoverage, isPending: true } };
    case GET_RATING_COVERAGE_SUCCESS:
      return { ...state, ratingCoverage: { data: payload, isPending: false } };
    case GET_RATING_COVERAGE_ERROR:
      return { ...state, ratingCoverage: { ...state.ratingCoverage, isPending: false } };
    case GET_ESG_COVERAGE:
      return { ...state, esgCoverage: { ...state.esgCoverage, isPending: true } };
    case GET_ESG_COVERAGE_SUCCESS:
      return { ...state, esgCoverage: { data: payload, isPending: false } };
    case GET_ESG_COVERAGE_ERROR:
      return { ...state, esgCoverage: { ...state.esgCoverage, isPending: false } };
    case GET_REGIONS:
      return { ...state, regions: { ...state.regions, isPending: true } };
    case GET_REGIONS_SUCCESS:
      return { ...state, regions: { data: payload, isPending: false } };
    case GET_REGIONS_ERROR:
      return { ...state, regions: { ...state.regions, isPending: false } };
    case REQUEST_QUESTIONNAIRE_AVAILABILITY_SUCCESS:
      return { ...state, questionnaire: { ...state.questionnaire, show: payload.show } };
    case REQUEST_QUESTIONNAIRE_AVAILABILITY_ERROR:
      return { ...state, questionnaire: { ...state.questionnaire, show: false } };
    default:
      return state;
  }
}
